import Container from '../../atoms/container/anonymousModalUpgrades';
import IconConcurrency from '../../../../shared/assets/images/png/anonymousModalConcurrency.png';
import IconGuide from '../../../../shared/assets/images/png/anonymousModalGuide.png';
import IconRecording from '../../../../shared/assets/images/png/anonymousModalRecording.png';
import IconRestart from '../../../../shared/assets/images/png/anonymousModalRestart.png';
import IconU7D from '../../../../shared/assets/images/png/anonymousModalU7d.png';
import Perk from './anonymousModalPerk';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';

function AnonymousModalUpgrades() {
  return (
    <Container>
      <Perk
        icon={IconRestart}
        labelBottom={TranslationManager.get(
          'MODAL.ANONYMOUS.ICONS.RESTART_BOTTOM'
        )}
        labelTop={TranslationManager.get('MODAL.ANONYMOUS.ICONS.RESTART_TOP')}
      />
      <Perk
        icon={IconU7D}
        labelBottom={TranslationManager.get('MODAL.ANONYMOUS.ICONS.U7D_BOTTOM')}
        labelTop={TranslationManager.get('MODAL.ANONYMOUS.ICONS.U7D_TOP')}
      />
      <Perk
        icon={IconRecording}
        labelBottom={TranslationManager.get(
          'MODAL.ANONYMOUS.ICONS.RECORDING_BOTTOM'
        )}
        labelTop={TranslationManager.get('MODAL.ANONYMOUS.ICONS.RECORDING_TOP')}
      />
      <Perk
        icon={IconGuide}
        labelBottom={TranslationManager.get(
          'MODAL.ANONYMOUS.ICONS.GUIDE_BOTTOM'
        )}
        labelTop={TranslationManager.get('MODAL.ANONYMOUS.ICONS.GUIDE_TOP')}
      />
      <Perk
        icon={IconConcurrency}
        labelBottom={TranslationManager.get(
          'MODAL.ANONYMOUS.ICONS.CONCURRENCY_BOTTOM'
        )}
        labelTop={TranslationManager.get(
          'MODAL.ANONYMOUS.ICONS.CONCURRENCY_TOP'
        )}
      />
    </Container>
  );
}

export default AnonymousModalUpgrades;
